import type * as THREE from 'three';
import { whenIdle } from './idle';
import { isModelMesh } from './picking';

/** Something worked out for each mesh of a model on first use, or ahead of it while the viewer is idle. */
export class PerMesh<T> {
  private readonly built = new Map<THREE.Mesh, T>();
  private cancelPrepare: (() => void) | null = null;

  constructor(
    private readonly model: THREE.Object3D,
    private readonly build: (mesh: THREE.Mesh) => T,
  ) {}

  of(mesh: THREE.Mesh): T {
    let value = this.built.get(mesh);
    if (value === undefined) {
      value = this.build(mesh);
      this.built.set(mesh, value);
    }
    return value;
  }

  prepare(): void {
    if (this.cancelPrepare) return;
    this.cancelPrepare = whenIdle(() => {
      this.cancelPrepare = null;
      this.model.traverse((child) => {
        if (isModelMesh(child)) this.of(child);
      });
    });
  }

  stop(): void {
    this.cancelPrepare?.();
    this.cancelPrepare = null;
  }
}
